import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'auto_release',
  label: {
    default: 'Have this Hold automatically expire at this time',
    short: 'Auto Release',
  },
});
